angular
  .module('data-ng-path-item')
  .constant('addTextByFieldByItemSubstitutionFunction', function addTextByFieldByItemSubstitution(tasks, items) {
    var lookupSubstitutionText = function lookupSubstitutionText(item, property) {
      var substitution = item._task.substitute_text_by_field_by_item;

      if (!substitution[item.id]) {
        return item[property];
      } else if (!substitution[item.id][property]) {
        return item[property];
      } else {
        return substitution[item.id][property];
      }
    };

    // TODO create just one function that accepts a property (substituteProperty)
    _.each(items, function (item) {
      item.getSubstitutionText = function getSubstitutionText() {
        return lookupSubstitutionText(this, 'text');
      };

      item.getSubstitutionTitle = function getSubstitutionTitle() {
        return lookupSubstitutionText(this, 'title');
      };
    });
  })
  .constant('PathItemBuilderDTD', {
    root: {
      optional: true,
      type: 'ngObject',
      typeDef: 'ItemBuilder',
      hint: {
        typeDTD: 'ItemBuilderDTD',
        length: 1
      }
    },
    task: {
      type: 'ngObject',
      typeDef: 'TaskBuilder',
      writeToKey: 'tasks',
      hint: {
        typeDTD: 'TaskBuilderDTD'
      }
    },
    requested_item_id: {
      writeToKey: 'rootItemId',
      type: 'integer'
    },
    item: {
      writeToKey: 'items',
      type: 'ngObject',
      typeDef: 'ItemBuilder',
      hint: {
        typeDTD: 'ItemBuilderDTD'
      }
    },
    option: {
      writeToKey: 'options',
      type: 'ngObject',
      typeDef: 'OptionBuilder',
      hint: {
        typeDTD: 'OptionBuilderDTD'
      }
    },
    action: {
      writeToKey: 'actions',
      type: 'ngObject',
      typeDef: 'ActionBuilder',
      hint: {
        typeDTD: 'ActionBuilderDTD'
      }
    },
    param: {
      writeToKey: 'constants',
      type: 'object'
    },
    range: {
      writeToKey: 'ranges',
      type: 'ngObject'
    },
    location: {
      writeToKey: 'locations',
      type: 'ngObject',
      typeDef: 'GeoJsonBuilder',
      hint: {
        typeDTD: 'GeoJsonBuilderDTD'
      }
    },
    location_group: {
      writeToKey: 'locationGroups',
      type: 'object',
      typeDef: {
        id: 'key',
        nk: 'string',
        locations: 'array'
      }
    }
  })
  .factory(
    'PathItemBuilder',
    function PathItemBuilder(
      Interface,
      PathItemBuilderDTD,
      TaskFn,
      pathItemContractModifierDecorator,
      addTextByFieldByItemSubstitutionFunction
    ) {
      var PathItemDTO = function PathItemDTO(data) {
        pathItemContractModifierDecorator.runExtensions(data, this);

        this.source = Interface.make(PathItemBuilderDTD, data);
        this.root = attachChildrenToItems(getRootItem(this.source), this.source.items);

        attachTasksToItems(this.source.tasks, this.source.items);
        attachOptionsToItems(this.source.options, this.source.items);
        attachActionsToOptions(this.source.actions, this.source.options);
        groupLocations(this.source.locationGroups, this.source.locations);
        attachAppointmentLinkToTask(this.source.tasks, this.root);

        // DEPRECATED (but capability-ng-survey requires the methods added to item)
        addTextByFieldByItemSubstitutionFunction(this.source.tasks, this.source.items);

        // REPLACE with these two which add the title to the task
        TaskFn.applySubstitutionToText(this.source.tasks, this.source.items, 'title');
        TaskFn.applySubstitutionToText(this.source.tasks, this.source.items, 'text');

        if (_.isPlainObject(this.source.task)) {
          this.source.task._item = this.root;
        }
      };

      /**
       * calculate the difference between all items and items that have never been referenced as children which is the root
       * @assumption all items are relevant and referenced by another item, except the root
       */
      var getRootItem = function getRootItem(source) {
        source.task = source.tasks[_.first(_.keys(source.tasks))];
        return source.items[source.task.item];
      };

      var attachChildrenToItems = function attachChildrenToItems(item, items) {
        item.children = _.map(
          item.children,
          function (childId) {
            var child = this[childId];

            child._parent = item;
            return attachChildrenToItems(child, this);
          },
          items
        );

        return item;
      };

      const attachAppointmentLinkToTask = (tasks, rootItem) => {
        _.each(tasks, (task) => {
          task._link_to_appt_scheduling = rootItem.link_to_appt_scheduling;
        });
      };

      var attachTasksToItems = function attachTasksToItems(tasks, items) {
        _.each(
          tasks,
          function (task) {
            this[task.item]._task = task;
          },
          items
        );

        _.each(items, function (item) {
          if (_.isUndefined(item._task) && !_.isUndefined(item._parent)) {
            item._task = item._parent._task;
          }
        });
      };

      var attachOptionsToItems = function attachOptionsToItems(options, items) {
        _.each(
          options,
          function (option) {
            this[option.item]._options[option.id] = option;
          },
          items
        );
      };

      var attachActionsToOptions = function attachActionsToOptions(actions, options) {
        _.each(
          actions,
          function (action) {
            this[action.option]._action = action;
          },
          options
        );
      };

      var groupLocations = function groupLocations(groups, locations) {
        _.forEach(groups, function (group) {
          group.locations = _.map(group.locations, function (locationId) {
            return locations[locationId];
          });
        });
      };

      return PathItemDTO;
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/data-ng-path-item/src/builders/path_item_builder.js